import moment from "moment";
import React, { useEffect } from "react";

const LogPopup = ({ setShowResponse, showResponse }) => {
  let closedDate;
  let closedTime;
  let selectedIssue;

  const getData = (data) => {
    let formatted = {};
    (data ?? [])?.forEach((item) => {
      let key;
      let accessor; 

      if (item?.receptionist) {
        key = "Hotel Receptionist";
        accessor = "receptionist_details";
      } else if (item?.owner) {
        key = "Hotel Owner";
        accessor = "owner_details";
      } else {
        key = "Vow Support";
        accessor = "admin_details";
      }
      formatted[key] = [
        ...(formatted[key] ?? []),
        {
          Responded_Date: item?.updated_at,
          Employee_ID: item?.[accessor]?.code,
          Closed_By: item?.[accessor]?.name,
          Description: item?.reply_messages?.join(" "),
        },
      ];
    });
    return formatted;
  };

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: "rgba(0,0,0,0.5)",
        display: "flex",
        alignItems: "flex-start", // instead of center
        padding: "24px 16px",
        justifyContent: "center",
        zIndex: 1000,
        overflow: "auto",
      }}
      onClick={() => setShowResponse?.(false)}
    >
      <div
        style={{
          background: "#fff",
          borderRadius: 12,
          padding: 30,
          width: 460,
          maxWidth: "90%",
          maxHeight: "calc(100vh - 48px)",
          overflowY: "auto",
        }}
        onClick={(e) => e.stopPropagation()}
      >
        {Object.entries(getData(showResponse)).map((item, ind) => {
          return (
            <div key={ind}>
              <div
                style={{
                  background: "#EDE9FE",
                  padding: "10px 5px",
                  textAlign: "center",
                  marginBottom: 10,
                  borderRadius: 10,
                }}
              >
                <p style={{ fontSize: 24, fontWeight: 600 }}>{item[0]}</p>
              </div>
              {item[1]?.map((values) => {
                return (
                  <div
                    style={{
                      borderBottom: "1px solid #CBD5E1",
                      marginTop: 30,
                      marginBottom: 30,
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        gap: 20,
                        marginBottom: 10,
                      }}
                    >
                      <div style={{ flex: 1 }}>
                        <p style={{ marginBottom: 8, fontWeight: 500 }}>
                          Issue Closed Date
                        </p>

                        <div
                          style={{
                            background: "#f5f5f7",
                            borderRadius: 8,
                            padding: "10px 14px",
                          }}
                        >
                          <p>
                            {values?.Responded_Date
                              ? moment(values?.Responded_Date).format(
                                  "DD/MM/YYYY",
                                )
                              : "-"}
                          </p>
                        </div>
                      </div>
                      <div style={{ flex: 1 }}>
                        <p style={{ marginBottom: 8, fontWeight: 500 }}>
                          Issue Closed Time
                        </p>

                        <div
                          style={{
                            background: "#f5f5f7",
                            borderRadius: 8,
                            padding: "10px 14px",
                          }}
                        >
                          <p>
                            {values?.Responded_Date
                              ? moment(values?.Responded_Date).format("hh:mm A")
                              : "-"}
                          </p>
                        </div>
                      </div>
                    </div>

                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        gap: 20,
                        marginBottom: 10,
                      }}
                    >
                      <div style={{ flex: 1 }}>
                        <p style={{ marginBottom: 8, fontWeight: 500 }}>
                          Employee ID
                        </p>
                        <div
                          style={{
                            background: "#f5f5f7",
                            borderRadius: 8,
                            padding: "10px 14px",
                          }}
                        >
                          <p>{values?.Employee_ID || "-"}</p>
                        </div>
                      </div>
                      <div style={{ flex: 1 }}>
                        <p style={{ marginBottom: 8, fontWeight: 500 }}>
                          Issue Closed By
                        </p>
                        <div
                          style={{
                            background: "#f5f5f7",
                            borderRadius: 8,
                            padding: "10px 14px",
                          }}
                        >
                          <p>{values?.Closed_By || "-"}</p>
                        </div>
                      </div>
                    </div>

                    <div style={{ marginBottom: 24 }}>
                      <p style={{ marginBottom: 8, fontWeight: 500 }}>
                        Description
                      </p>

                      <div
                        style={{
                          background: "#f5f5f7",
                          borderRadius: 8,
                          padding: "10px 14px",
                          minHeight: 60,
                        }}
                      >
                        <p>{values?.Description || "-"}</p>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default LogPopup;
